/**
 * Get the theme state
 * @category Core
 */
export const gridThemeSelector = state => state.theme;